import React from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import { InputLabel } from '@mui/material';
import {getFeet, getInches} from '../utils/utils'

function CustomInput({question, value, error, handleChange, index}) {
  const {id, type, choices} = question;

  return (
   <>
    {(() => {
        switch (type) {
          case 'input':
          case 'number':

            return <TextField onChange={handleChange} type={type} 
                    name={id} size='small' value={value}
                    sx={{width: '100%', paddingRight:'5px'}}
                    inputProps={{style: { padding: '3.5px 5px', fontSize:15,  border: error ? '2px solid red' : ''  }}}  
                  />
          case 'select':
            return <FormControl  sx={{ m: 0, width: '100%', paddingRight:'5px', whiteSpace :'pre-wrap'}} size="small">
                    <Select
                      name={id}
                      value={value || ""}
                      sx={{ width: '100%',height: 30,margin: 0,  border: error ? '2px solid red' : '', '.MuiSelect-select':{paddingLeft:'5px'} }}
                      onChange={handleChange} 
                    >
                    {choices && choices.map((option) =>
                      <MenuItem value={option.value}>{option.display}</MenuItem>
                    )}
                     
                    </Select>
                  </FormControl>
          case 'checkbox':
            return <Checkbox  
                      onChange={handleChange} 
                      name={id} 
                      checked={value || false}
                       />
          case 'height' :
          return <div style={{display:'flex'}}>
                  <FormControl sx={{width: '100%', m: 0, paddingRight:'5px', whiteSpace :'pre-wrap'}} size="small">
                    <InputLabel id="demo-select-small-label">Feet</InputLabel>
                    <Select
                      name="feet"
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      defaultValue={Math.round(getFeet(value))}
                      label="Feet"
                      sx={{ width: '70%',height: 30,margin: 0,  border: error ? '2px solid red' : '', '.MuiSelect-select':{paddingLeft:'5px'} }}
                      onChange={handleChange} 
                     
                    >
                    {[1,2,3,4,5,6,7].map((option) =>
                      <MenuItem value={option}>{option}</MenuItem>
                    )}
                    </Select>
                  </FormControl>           
                  <FormControl sx={{ width: '100%', m: 0,  paddingRight:'5px', whiteSpace :'pre-wrap'}} size="small">
                    <InputLabel id="demo-select-small-label">Inches</InputLabel>
                    <Select
                      name="inches"
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      defaultValue={getInches(value)}
                      label="Inches"
                      sx={{ width: '70%',height: 30,margin: 0,  border: error ? '2px solid red' : '', '.MuiSelect-select':{paddingLeft:'5px'} }}
                      onChange={handleChange} 
                     
                    >
                    {[1,2,3,4,5,6,7,8,9,10,11].map((option) =>
                      <MenuItem value={option}>{option}</MenuItem>
                    )}
                    </Select>
                  </FormControl>

                 
                  </div> 
          case 'activityWithRating':
            return  <FormControl sx={{width: '100%', m: 0, paddingRight:'5px', whiteSpace :'pre-wrap'}} size="small">
                    <InputLabel id="demo-select-small-label">Select</InputLabel>
                    <Select
                      name={id}
                      labelId="demo-select-small-label"
                      id="demo-select-small"
                      defaultValue={value?.rating || ""}
                      label="Activities"
                      sx={{ width: '100%', height: 30, margin: 0,  border: error ? '2px solid red' : '', '.MuiSelect-select':{paddingLeft:'5px'}}}
                      onChange={handleChange} 
                    >
                    {[
                      {id:0, item:'0 = Unable to perform activity'},
                      {id:1, item:1},
                      {id:2, item:2},
                      {id:3, item:3},
                      {id:4, item:4},
                      {id:5, item:5},
                      {id:6, item:6},
                      {id:7, item:7},
                      {id:8, item:8},
                      {id:9, item:9},
                      {id:10, item: '10 = Able to perform the activity'}].map((optionObj) =>
                      <MenuItem value={optionObj.id}>{optionObj.item}</MenuItem>
                    )}
                    </Select>
                  </FormControl>
          default:
            return null
        }
      })()}
    </>
  )
}

export default CustomInput